import styled from 'styled-components';
import { halfStep } from 'tokens';

export type BaseProps = {
	readonly?: boolean;
};
export const Base = styled.div<BaseProps>`
	flex: 1;
	display: flex;
	align-items: center;
	width: 100%;
	box-sizing: border-box;
	margin-top: 8px;
	height: 24px;
	overflow: hidden;
	gap: 8px;
	padding-left: 6px;
	padding-right: 6px;
	color: ${({ theme }) => theme.gray[1000]};

	background: ${({ theme, readonly }) => (readonly ? 'transparent' : theme.gray[100])};
	border: ${({ readonly, theme }) =>
		readonly ? `1px solid ${theme.gray[200]}` : '1px solid transparent'};

	border-radius: ${halfStep}px;
	user-select: none;
`;

export const LetterLabel = styled.div`
	font-size: 12px;
	font-weight: 500;
	display: flex;
	align-items: center;
	color: ${({ theme }) => theme.gray[600]};
	margin-top: 1px;
`;
